import React from 'react';

import { usePfeTileConfigSlice } from 'widgets/signalTiles/pfeTile/state';
import { SignalTile } from 'widgets/signalTiles/signalTile/components/SignalTile';

import PfeTileChartHelp from './chart/help/PfeTileChartHelp';

import './PfeTile.scss';
import { pfeStreamedDataSelectors } from 'widgets/signalTiles/pfeTile/state';
import { pfeTileProps } from 'widgets/signalTiles/pfeTile/components/pfeTileProps';

const { useWidgetStreamData, useWidgetMessages } = pfeStreamedDataSelectors;

export function PfeTile() {
    const { config, dispatchConfigChanged } = usePfeTileConfigSlice();
    const streamData = useWidgetStreamData();
    const messages = useWidgetMessages();

    return (
        <SignalTile
            className="PfeTile"
            config={config}
            stream={streamData}
            messages={messages}
            dispatchConfigChanged={dispatchConfigChanged}
            settingsHeader={`PFE Capsule Settings`}
            title="PFE"
            help={<PfeTileChartHelp />}
            {...pfeTileProps}
        />
    );
}
